<div class="contact-soc-dialog">
    <app-popup-top-line></app-popup-top-line>
    <div class="contact-soc-dialog-header">
        <div class="title">
            Route to SOC
            <div class="description">Report a security incident to your preferred SIEM/SOAR system</div>
        </div>
        <img class="close-button" src="assets/images/common/cancel.svg" (click)="onClose()" />
    </div>
    <div class="contact-soc-dialog-body">
        <div class="soc-form">
            <label for="title" class="soc-form-label">Configure incident</label>
            <div class="soc-details-inputs">
                <div class="soc-form-title-inputs">
                    <label for="title" class="soc-form-label">Title</label>
                    <input type="text" id="title" class="soc-form-input" placeholder="Data Exfiltration Using Prompt Injection" />
                </div>
                <div class="soc-form-severity-inputs">
                    <label for="severity" class="soc-form-label">Severity</label>
                    <select id="severity" class="soc-severity">
                        <option value="low">Low</option>
                        <option value="medium">Medium</option>
                        <option value="high" selected>High</option>
                    </select>
                </div>
            </div>

            <label for="description" class="soc-form-label">Description</label>
            <div class="textarea">
                <textarea id="description" class="soc-form-textarea" [(ngModel)]="data.incidentDescription"></textarea>
            </div>

            <div class="soc-form-incident">
                <label for="system" class="soc-form-label">Creating incident in</label>
                <select id="system" class="soc-form-select">
                    <option value="sentinel">Microsoft Sentinel</option>
                </select>
            </div>
        </div>
    </div>

    <br /><br /><br />
    <div class="contact-soc-dialog-footer">
        <div class="contact-soc-dialog-buttons-container">
            <div class="soc-footer">
                <button type="button" class="soc-footer-button" (click)="onCreateIncidentClick()">
                    <span *ngIf="!waitingForResponse">Create Incident</span>
                    <mat-progress-spinner class="spinner" *ngIf="waitingForResponse" color="primary" mode="indeterminate"></mat-progress-spinner>
                </button>
            </div>
        </div>
    </div>
</div>
